import httpClient from '@/api/http-client';

const endpoint = 'api/permit-fields';

const permitFieldService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  create: (permitField) => httpClient.post(`${endpoint}`, permitField),

  update: (permitField) => httpClient.put(`${endpoint}/${permitField.id}`, permitField),

  delete: (permitField) => httpClient.delete(`${endpoint}/${permitField.id}`),
};

export default permitFieldService;
